import React from 'react';
import * as styles from '../styles/components/context-menu.css.ts';

interface CellContextMenuProps {
  visible: boolean;
  x: number;
  y: number;
  cellValue: unknown;
  onCopy: () => void;
  onClose: () => void;
}

export const CellContextMenu: React.FC<CellContextMenuProps> = ({
  visible,
  x,
  y,
  onCopy,
  onClose
}) => {
  if (!visible) return null;

  return (
    <div
      data-testid="cell-context-menu"
      className={styles.contextMenu}
      style={{ left: x, top: y }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className={styles.contextMenuItem}
        onClick={() => {
          onCopy();
          onClose();
        }}
      >
        Copy Cell Value
      </button>
    </div>
  );
};
